import React from 'react';
import {Button, CardContent, CardMedia, Typography, Stack} from '@mui/material';

import {translations} from 'presentation/translations-new';
import Icon from 'presentation/icons';
import {useMediaQueries} from 'presentation/pages/private/hooks';
import {Loading} from 'presentation/components/Loading/Loading';
import {StyledCard, StyledCardActions, StyledImageContainer} from './styles';
import {PerksCardProps} from './types';

const {access} = translations['pt-br'].commons;

export function PerksCard({
	cardImage,
	description,
	handleAction,
	title,
	isLoading,
	dataTagId,
	buttonText = access,
	buttonIcon = 'arrow-right-filled',
}: PerksCardProps) {
	const {isTablet} = useMediaQueries();

	return (
		<StyledCard elevation={0}>
			<Stack flexDirection={isTablet ? 'row' : 'column'} height="100%">
				<StyledImageContainer>
					<CardMedia component="img" image={cardImage} title={title} />
				</StyledImageContainer>
				<Stack flex={3} justifyContent="space-between">
					<CardContent sx={{paddingBottom: 0}}>
						<Typography component="h2" variant="alertTitle">
							{title}
						</Typography>
						<Typography variant="body2">{description}</Typography>
					</CardContent>
					<StyledCardActions>
						<Button
							data-tag-id={dataTagId}
							disabled={isLoading}
							onClick={handleAction}
							size={isTablet ? 'small' : 'medium'}
							variant="text"
							endIcon={
								isLoading ? (
									<Loading size={isTablet ? 18 : 20} color="inherit" />
								) : (
									<Icon name={buttonIcon} size={isTablet ? 18 : 20} />
								)
							}>
							{buttonText}
						</Button>
					</StyledCardActions>
				</Stack>
			</Stack>
		</StyledCard>
	);
}
